import { apiSlice } from '@/core/api/apiSlice';
import { ApiResponse } from '@/types/common.types';
import { SignupRequest, LoginRequest, AuthResponseData } from '@/types/auth.types';

export const authApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        adminSignup: builder.mutation<ApiResponse<AuthResponseData>, SignupRequest>({
            query: (credentials) => ({
                url: '/auth/signup',
                method: 'POST',
                body: credentials,
            }),
        }),
        adminLogin: builder.mutation<ApiResponse<AuthResponseData>, LoginRequest>({
            query: (credentials) => ({
                url: '/auth/login',
                method: 'POST',
                body: credentials,
            }),
        }),
        forgotPassword: builder.mutation<ApiResponse<null>, { email: string }>({
            query: (body) => ({
                url: '/auth/forgot-password',
                method: 'POST',
                body,
            }),
        }),
        resetPassword: builder.mutation<ApiResponse<null>, { token: string; new_password: string }>({
            query: (data) => ({
                url: '/auth/reset-password',
                method: 'POST',
                body: data,
            }),
        }),
        validateResetToken: builder.query<ApiResponse<null>, string>({
            query: (token) => ({
                url: `/auth/reset-password/validate?token=${token}`,
                method: 'GET',
            }),
        }),
    }),
});

export const {
    useAdminSignupMutation,
    useAdminLoginMutation,
    useForgotPasswordMutation,
    useResetPasswordMutation,
    useValidateResetTokenQuery,
} = authApi;
